import Cookies from 'js-cookie';
var TokenKey = 'e_his_token';
var TokenUserInfo = 'e_his_userInfo';
var TokenRouter = 'e_his_router';
export function getToken() {
  return Cookies.get(TokenKey);
}
export function setToken(token) {
  return Cookies.set(TokenKey, token);
}
export function removeToken() {
  return Cookies.remove(TokenKey);
}
export function setUserInfo(data) {
  return localStorage.setItem(TokenUserInfo, data);
}
export function getUserInfo() {
  return localStorage.getItem(TokenUserInfo);
}
export function removeUserInfo() {
  return localStorage.removeItem(TokenUserInfo);
}
export function setRouters(arr) {
  return localStorage.setItem(TokenRouter, arr);
}
export function getRouters() {
  return localStorage.getItem(TokenRouter);
}